import { useQuery } from '@tanstack/react-query';
import { executeQuery } from '@/lib/execute-query';
import { Action } from '@/business/types/action.types';

export function createQueryHook<
  TParams = void,
  TInput = unknown,
  TOutput = unknown,
>(config: {
  action: Action;
  queryKey: (params: TParams) => readonly unknown[];
  buildInput: (params: TParams) => TInput;
  staleTime: number;
  enabled?: (params: TParams) => boolean;
  refetchOnWindowFocus?: boolean;
}) {
  return (params?: TParams) =>
    useQuery({
      queryKey: config.queryKey(params as TParams),
      queryFn: () =>
        executeQuery<TInput, TOutput>(
          config.action,
          config.buildInput(params as TParams)
        ),
      staleTime: config.staleTime,
      ...(config.enabled && { enabled: config.enabled(params as TParams) }),
      ...(config.refetchOnWindowFocus !== undefined && {
        refetchOnWindowFocus: config.refetchOnWindowFocus,
      }),
    });
}
